import { useEffect } from "react";

import Text from "ab-text";
import ProductCard from "ab-card-product";
import Tag from "ab-tag";
import Link from "ab-link";
import { gtmProductImpressions } from "ab-gtm";

import "./ab-products.scss";

const Products = ({
  title,
  description,
  products = [],
  className = "",
  tag,
  animated,
  link,
  h1,
  i18n,
}) => {
  // console.log("Products", products);
  const isSeleccionNavidad = products?.find(
    (itm) => itm?.location === "Un vino para los tuyos a un precio especial"
  );
  const isEstuches = products?.find(
    (itm) =>
      itm?.location === "Estuches Personalizados" ||
      itm?.location === "Personalized Cases" ||
      itm?.location === "Personalisierte Weinboxen"
  );
  useEffect(() => {
    gtmProductImpressions(products);
  }, []);
  return (
    <div className={`ab-products ${className || ""}`}>
      {h1 ? <Text element="h1">{h1}</Text> : null}
      <div className="row">
        {title || description ? (
          <div className="details">
            {tag ? <Tag>{tag}</Tag> : null}
            <Text element="h2" animated={animated}>
              {title}
            </Text>
            <Text className={isSeleccionNavidad ? "seleccion-navidad" : ""}>
              {description}
            </Text>
            {link ? (
              <Link prefetch={false} text={link.text} href={link.href} />
            ) : null}
          </div>
        ) : null}

        <div className={`products`}>
          {products.map((itm, index) => (
            <>
              <ProductCard
                key={`product-card-${index}-${itm.slug || ""}`}
                src={itm.src}
                label={itm.price}
                hidePrice={!isSeleccionNavidad && isEstuches}
                title={itm.name}
                personalizar={itm.personalizar}
                description={itm.description}
                plus={itm.type === "GROUPED"}
                href={itm.href}
                attributes={itm?.attributes}
                products={itm?.products}
                i18n={i18n}
                product={itm}
                esEstuche={isEstuches}
                inStock={itm?.stockStatus === "IN_STOCK"}
                isSeleccionNavidad={isSeleccionNavidad}
              />
            </>
          ))}
        </div>

        {link ? (
          <Link prefetch={false} text={link.text} href={link.href} />
        ) : null}
      </div>
    </div>
  );
};

export default Products;
